import React, { useState } from 'react';

import FieldTextInput from '../FieldTextInput/FieldTextInput';

import css from './FieldPasswordInput.module.css';

const EyeIcon = ({ isPasswordVisible }) => (
  <svg aria-hidden="true" className={css.icon} viewBox="0 0 24 24">
    <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z" />
    <circle cx="12" cy="12" r="3" />
    {isPasswordVisible ? null : <path d="m4 4 16 16" />}
  </svg>
);

const FieldPasswordInput = props => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const toggleLabel = isPasswordVisible ? 'Ocultar contraseña' : 'Mostrar contraseña';

  return (
    <FieldTextInput
      {...props}
      type={isPasswordVisible ? 'text' : 'password'}
      inputEndAdornment={
        <button
          className={css.toggleButton}
          type="button"
          aria-label={toggleLabel}
          aria-pressed={isPasswordVisible}
          onClick={() => setIsPasswordVisible(visible => !visible)}
        >
          <EyeIcon isPasswordVisible={isPasswordVisible} />
        </button>
      }
    />
  );
};

export default FieldPasswordInput;
